<template>
  <header id="header-navbar" class="header">
    <div class="destra">
      <button class="menu-btn" @click="toggleMenu">
        <svg
          viewBox="0 0 24 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          fill="#000000"
          class="w-full h-[40px]"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            <title>Menu</title>
            <g
              id="Page-1"
              stroke="none"
              stroke-width="1"
              fill="none"
              fill-rule="evenodd"
            >
              <g id="Menu">
                <rect
                  id="Rectangle"
                  fill-rule="nonzero"
                  x="0"
                  y="0"
                  width="24"
                  height="24"
                ></rect>
                <line
                  x1="5"
                  y1="7"
                  x2="19"
                  y2="7"
                  id="Path"
                  stroke="#0C0310"
                  stroke-width="2"
                  stroke-linecap="round"
                ></line>
                <line
                  x1="5"
                  y1="17"
                  x2="19"
                  y2="17"
                  id="Path"
                  stroke="#0C0310"
                  stroke-width="2"
                  stroke-linecap="round"
                ></line>
                <line
                  x1="5"
                  y1="12"
                  x2="19"
                  y2="12"
                  id="Path"
                  stroke="#0C0310"
                  stroke-width="2"
                  stroke-linecap="round"
                ></line>
              </g>
            </g>
          </g>
        </svg>
      </button>
      <router-link
        :to="logoRoute"
        title="Dashboard"
        class="logo-container"
      >
        <img :src="getUrlLogo" alt="Logo" class="logo small-logo" />
      </router-link>
      <!-- <button @click="globalSearchModal" class="global-search">
        <i class="fa-solid fa-magnifying-glass"></i>
      </button> -->

      <div class="flex items-stretch gap-2 min-w-fit">
        <CategoriesMegaMenu ref="categoriesModalRef" />
        <div class="hidden md:flex items-stretch gap-2">
          <ProvidersMegaMenu />
        </div>
        <SkinsMegaMenu ref="skinsModalRef" />
      </div>
    </div>

    <div class="controls" v-if="selectedDatabase">
      <div class="flex items-center gap-2">
        <UtiliesMenuApps ref="utilitiesRef" />

        <div class="flex md:hidden items-center">
          <MobileControlsMenu
            :url-crash="urlCrash"
            :has-crash="hasCrash"
            :has-live-casino="hasLiveCasino"
            @open-categories="openCategoriesModal"
            @open-skins="openSkinsModal"
            @open-utilities="openUtilities"
          />
        </div>
      </div>
    </div>
  </header>

  <div v-if="showModal" class="modal-overlay" @click="closeDatabaseModal">
    <div class="modal-content" @click.stop>
      <button @click="closeDatabaseModal" class="close-modal">
        <span>×</span>
      </button>

      <h3 class="modal-title mb-2">Change Game</h3>

      <div v-if="0" class="search-container">
        <input
          v-model="searchQuery"
          type="text"
          placeholder="Search games..."
          class="search-input"
        />
      </div>

      <div
        v-if="Object.keys(filteredGroupedGames).length === 0"
        class="no-results"
      >
        No games found. Try a different search term.
      </div>
      <div v-else class="games-container">
        <div
          v-for="(games, letter) in filteredGroupedGames"
          :key="letter"
          class="letter-group"
        >
          <div class="games-grid">
            <button
              v-for="game in games"
              :key="game.name"
              :title="game.label"
              class="game-button"
              :class="{
                'game-button--active': selectedDatabase === game.name,
              }"
              @click="selectDatabase(game.name)"
              :disabled="selectedDatabase === game.name"
            >
              <img
                class="game-icon"
                :class="game.isFullWidth ? 'full-w-icon' : ''"
                :src="game.icon"
                :alt="game.label"
              />
              <span class="game-label">{{ game.label }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import searchModalStore from "./GlobalSearch/searchStore";
import UtiliesMenuApps from "./UtlitiesMenuApps.vue";
import MobileControlsMenu from "./MobileControlsMenu.vue";
import CategoriesMegaMenu from "./Navigation/CategoriesMegaMenu.vue";
import ProvidersMegaMenu from "./Navigation/ProvidersMegaMenu.vue";
import SkinsMegaMenu from "./Navigation/SkinsMegaMenu.vue";
import { useHeaderNavigation } from "@/composables/useHeaderNavigation";
import { getActiveProvider, getActiveProviderSlug } from "../helpers/provider";

const route = useRoute();
const store = useStore();
const { openMenu } = useHeaderNavigation();

const activeSection = computed(() => {
  if (route?.meta?.section) return route.meta.section;
  if (route?.path?.includes("/livecasino")) return "livecasino";
  if (route?.path?.includes("/instant")) return "instant";
  return "slot";
});

const getSectionRoute = (section) => {
  const currentLang =
    route?.params?.lang || localStorage.getItem("locale") || "en";
  const skinFilt = route?.params?.skinFilt || store?.state?.skinStorage;
  const params = { lang: currentLang };
  if (skinFilt && skinFilt !== "all") {
    params.skinFilt = skinFilt.toString();
  }
  if (section === "slot") {
    return { name: "Home", params };
  } else if (section === "livecasino") {
    return { name: "LiveCasinoHome", params };
  } else if (section === "instant") {
    return { name: "InstantHome", params };
  }
  return {
    path: `/${currentLang}${skinFilt ? `/${skinFilt}` : ""}/${section}`,
  };
};

const logoRoute = computed(() => {
  return getSectionRoute(activeSection.value);
});

const categoriesModalRef = ref(null);
const skinsModalRef = ref(null);
const utilitiesRef = ref(null);

const openCategoriesModal = () => {
  if (
    categoriesModalRef.value &&
    typeof categoriesModalRef.value.openModal === "function"
  ) {
    categoriesModalRef.value.openModal();
  } else {
    openMenu("categories");
  }
};

const openSkinsModal = () => {
  if (
    skinsModalRef.value &&
    typeof skinsModalRef.value.openModal === "function"
  ) {
    skinsModalRef.value.openModal();
  } else {
    openMenu("skins");
  }
};

const parseEnvBoolean = (val, defaultValue = true) => {
  if (val === undefined || val === null || val === "") return defaultValue;
  return String(val).toLowerCase() !== "false" && val !== "0" && val !== 0;
};

const hasLiveCasino = parseEnvBoolean(process.env.VUE_APP_HASLIVECASINO, true);
const hasCrash = parseEnvBoolean(process.env.VUE_APP_HASCRASH, true);

const openUtilities = () => {
  if (
    utilitiesRef.value &&
    typeof utilitiesRef.value.toggleDropdown === "function"
  ) {
    utilitiesRef.value.toggleDropdown();
  }
};

const showModal = ref(false);
const showLanguageModal = ref(false);
const showGlobalSearch = ref(false);

const globlaSearchOpen = computed(
  () => searchModalStore.state.isSearchModalOpen,
);
const selectedDatabase = computed(() => store.getters.selectedDatabase);
const searchQuery = ref("");

const languages = [
  { code: "en", name: "English", flag: "/flag/en.png" },
  { code: "es", name: "Spanish", flag: "/flag/es.png" },
  { code: "it", name: "Italian", flag: "/flag/it.png" },
];

const currentLanguage = computed(() => localStorage.getItem("locale") || "en");
const currentLangObj = computed(
  () => languages.find((lang) => lang.code === currentLanguage.value) || {},
);

const toggleLanguageModal = () => {
  showLanguageModal.value = !showLanguageModal.value;
};
const token = localStorage.getItem("botokentheear") ?? null;
const bocrash = process.env.VUE_APP_URLBO_CRASHGAME;
const urlCrash = token ? bocrash + "/verifytoken/" + token : bocrash;
const closeLanguageModal = () => {
  showLanguageModal.value = false;
};
const providerSlug = computed(() => getActiveProviderSlug());
const getUrlLogo = computed(() => {
  const provider = getActiveProviderSlug() || "theearcasino";
  const cat = activeSection.value || "slot";
  return `https://storage.googleapis.com/camasy-images/${provider}/logo_promotool_${cat}.png`;
});
const gamesList = computed(() => [
  {
    name: "theearcasino",
    label: "The Ear Casino",
    icon: `https://storage.googleapis.com/camasy-images/avataraugustus/theearcasino_${activeSection.value}.png`,
    isFullWidth: false,
  },
]);

const groupedGames = computed(() => {
  return gamesList.value.reduce((acc, game) => {
    const letter = game.name;
    if (!acc[letter]) acc[letter] = [];
    acc[letter].push(game);
    return acc;
  }, {});
});

const filteredGroupedGames = computed(() => {
  if (!searchQuery.value) return groupedGames.value;
  const filtered = {};
  Object.keys(groupedGames.value).forEach((letter) => {
    const filteredGames = groupedGames.value[letter].filter((game) =>
      game.label.toLowerCase().includes(searchQuery.value.toLowerCase()),
    );
    if (filteredGames.length > 0) {
      filtered[letter] = filteredGames;
    }
  });
  return filtered;
});

const toggleMenu = () => {
  const currentMenuState = store.state.isMenuOpen;
  store.commit("setIsMenuOpen", !currentMenuState);

  let Utility = document.getElementById("utlity-menu-overlay");
  if (Utility) {
    Utility.click();
  }
};

const showUtilitiesMenu = () => {
  const currentMenuState = store.state.isUtilitiesMenuOpen;
  store.commit("setIsUtilitiesMenuOpen", !currentMenuState);
};

const openDatabaseModal = () => {
  showModal.value = true;
  document.body.style.overflow = "hidden";
};

const closeDatabaseModal = () => {
  showModal.value = false;
  document.body.style.overflow = "";
};

const selectDatabase = (dbName) => {
  if (selectedDatabase.value === dbName) return;
  store.commit("SET_SELECTED_DATABASE", dbName);
  showModal.value = false;
  window.location.href = "/";
};

const globalSearchModal = () => {
  const currentState = searchModalStore.state.isSearchModalOpen;
  searchModalStore.commit("setSearchOpen", !currentState);
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/components/header.scss";

.letter-group {
  width: 100%;
}

.letter-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 5px;
  color: rgb(74, 222, 128);
  padding-bottom: 8px;
  text-align: start;
}

.btn-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.db-option {
  border: none;
  padding: 10px 10px 10px 0px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-radius: 5px;
}

.disabled-btn {
  opacity: 0.5;
  cursor: not-allowed;
}

.game-icon {
  width: 30px;
  height: 30px;
  position: relative;
  left: -8px;
}

.skin-icon {
  width: 30px;
  height: 30px;
  position: relative;
  left: -8px;
}

.games-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  place-items: start;
  padding-right: 0.55rem;
  padding-top: 0.65rem;
  overflow: auto;
  scrollbar-color: rgba(255, 255, 255, 0.644) transparent;
}

.min-w-90 {
  min-width: 90px;
}

.change-skin-button,
.db-select-button {
  background-color: #1c4c63;
  color: white;
  border: none;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  border-radius: 6px;
  transition: background-color 0.3s ease;
  border: 1px solid white;
  padding: 8px;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    position: relative;
    left: 0;
  }

  @media (max-width: 657px) {
    padding: 0 !important;
  }
}

.change-skin-button:hover,
.db-select-button:hover {
  background-color: #1c4c63;
  border: 1px solid #1c4c63;
  transform: none;
  text-decoration: underline;
  transition: background-color 0.3s ease;
  color: white;
  position: relative;
}

.change-skin-button {
  @media (max-width: 767px) {
    background-color: #1c4c63;
    border: 1px solid #1c4c63;
    min-width: 60px;
  }
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 123456789000;
}

.modal-content {
  background: rgb(14 44 75 / 72%);
  padding: 30px 20px 20px;
  border-radius: 8px;
  text-align: center;
  width: 90%;
  height: 90%;
  max-height: 450px;
  max-width: 600px;
  border: 2px solid rgba(255, 255, 255, 0.1);
  position: relative;
  -webkit-animation: scale-in-center 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)
    both;
  animation: scale-in-center 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;

  @-webkit-keyframes scale-in-center {
    0% {
      -webkit-transform: scale(0);
      transform: scale(0);
      opacity: 1;
    }

    100% {
      -webkit-transform: scale(1);
      transform: scale(1);
      opacity: 1;
    }
  }

  @keyframes scale-in-center {
    0% {
      -webkit-transform: scale(0);
      transform: scale(0);
      opacity: 1;
    }

    100% {
      -webkit-transform: scale(1);
      transform: scale(1);
      opacity: 1;
    }
  }
}

.db-option {
  width: auto;
  margin-bottom: 10px;
  border: none;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  border-radius: 6px;
  transition: background-color 0.3s ease;
  color: white;
  margin: 0px auto;
  position: relative;

  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
}

.close-modal {
  background: $secondary-color;
  border: none;
  padding: 5px;
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  // cursor: pointer;
  font-weight: bold;
  color: white;
  position: absolute;
  right: 8px;
  top: 8px;
  font-size: 14px;
  transition: 0.3s all ease;
}

.close-modal:hover {
  transform: scale(0.9);
  transition: 0.3s all ease;
}

.change-game-title {
  font-size: clamp(17px, 1vw, 25px);
  margin: 0;
  text-transform: uppercase;
  color: rgb(74, 222, 128);
}

.game-icon {
  max-width: 30px;
  max-height: 30px;
  object-fit: contain;
  margin-right: 5px;
}

.disabled-btn {
  opacity: 0.7;
  cursor: not-allowed;
  pointer-events: none;
  color: greenyellow;
  text-decoration: underline;
}

.btn-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.change-game-svg {
  max-width: 20px;
  max-height: 20px;
  margin: 0px 4px;
}

.custom-search-input {
  padding: 5px;
  border-radius: 8px;
  margin-top: 10px;
  max-width: 70%;
  text-indent: 4px;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: all 0.3s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
  transform: scale(0.95);
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 123456789000;
  padding: 1rem;
}

.modal-content {
  background: linear-gradient(145deg, #1a2942, #0f1825);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 2.1rem 1rem 1.5rem 1rem;
  width: 100%;
  height: 90%;
  max-width: 600px;
  overflow: hidden;
  position: relative;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4);
}

.modal-title {
  color: rgb(74, 222, 128);
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.close-modal {
  position: absolute;
  top: 10px;
  right: 5px;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  color: white;
  font-size: 1.5rem;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
    transform: rotate(90deg);
  }
}

.search-container {
  padding: 10px 0px 15px;
}

.search-input {
  width: 100%;
  padding: 0.75rem 1rem;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(0, 0, 0, 0.2);
  color: white;
  font-size: 1rem;
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: rgb(74, 222, 128);
    box-shadow: 0 0 0 2px rgba(74, 222, 128, 0.2);
  }

  &::placeholder {
    color: rgba(255, 255, 255, 0.5);
  }
}

.games-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 5px;
}

.games-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100%, 1fr));
  width: 100%;
  min-width: 100%;
}

.game-button {
  background: rgba(255, 255, 255, 0.05);
  border: 2px solid rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  padding: 1rem;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
  color: white;
  width: 100%;
  min-width: 100%;

  &:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.1);
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
  }

  &--active {
    background: rgba(74, 222, 128, 0.1);
    border-color: rgb(74, 222, 128);
    pointer-events: none;

    .game-label {
      color: rgb(74, 222, 128);
    }
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.game-icon {
  width: 32px;
  height: 32px;
  object-fit: contain;
}

.game-label {
  font-weight: 500;
  font-size: 80%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.change-game-svg {
  width: 20px;
  height: 20px;
}

.no-results {
  color: white;
  letter-spacing: -0.04em;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  -webkit-animation: text-focus-in 0.6s cubic-bezier(0.55, 0.085, 0.68, 0.53)
    both;
  animation: text-focus-in 0.6s cubic-bezier(0.55, 0.085, 0.68, 0.53) both;

  @-webkit-keyframes text-focus-in {
    0% {
      -webkit-filter: blur(12px);
      filter: blur(12px);
      opacity: 0;
    }

    100% {
      -webkit-filter: blur(0px);
      filter: blur(0px);
      opacity: 1;
    }
  }

  @keyframes text-focus-in {
    0% {
      -webkit-filter: blur(12px);
      filter: blur(12px);
      opacity: 0;
    }

    100% {
      -webkit-filter: blur(0px);
      filter: blur(0px);
      opacity: 1;
    }
  }
}

.full-w-icon {
  width: 100%;
  height: 30px;
  max-width: 100%;
  max-height: 100%;
}

.global-search {
  border-radius: 50%;
  border: 2px solid var(--primary-color, #386f99);
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1rem;
  padding: 15px;
  background: var(--primary-color, #386f99);

  @media (max-width: 650px) {
    font-size: 0.75rem;
    width: 20px;
    height: 20px;
  }
}

.logo {
  &.small-logo {
    @media (max-width: 650px) {
      max-width: 75px;
    }
  }
}

button {
  &.utility-menu-app {
    border: 1px solid white !important;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      color: white !important;
      transform: scale(1) !important;
    }
  }
}

.section-switcher {
  background: #f1f5f9;
  border-radius: 12px;
  padding: 4px;
  border: 1px solid #e2e8f0;
  margin-left: 0.5rem;
}

.section-tab {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
  color: #64748b;
  text-decoration: none;
  transition: all 0.2s ease;
  white-space: nowrap;

  &:hover {
    color: #0f172a;
    background: rgba(255, 255, 255, 0.7);
    text-decoration: none;
  }

  &--active {
    background: var(--primary-color, #386f99);
    color: #ffffff !important;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

    &:hover {
      background: var(--primary-color, #386f99);
      color: #ffffff !important;
    }
  }
}
</style>
